(function () {
  const DRAG_THRESHOLD = 8;
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function initTrack(track) {
    if (!mobileQuery.matches) return;
    if (track.dataset.wired === 'true') return;
    track.dataset.wired = 'true';

    let scrollStart = 0;

    track.addEventListener(
      'touchstart',
      () => {
        scrollStart = track.scrollLeft;
      },
      { passive: true }
    );

    track.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (Math.abs(track.scrollLeft - scrollStart) > DRAG_THRESHOLD) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.js-product-card-image-track').forEach(initTrack);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
